import configuration from './../config.json'
import reportService from '../shared/services/reportService'
import CookieService from './../shared/services/cookiesService'
import { setLogout } from './authActions'

const REQUEST_GET_SAVED_REPORTS = 'REQUEST_GET_SAVED_REPORTS'
const RESPONSE_GET_SAVED_REPORTS = 'RESPONSE_GET_SAVED_REPORTS'
const REQUEST_GET_SAVED_REPORTS_FAILURE = 'REQUEST_GET_SAVED_REPORTS_FAILURE'

const requestGetSavedReportsAction = () => {
  return {
    type: REQUEST_GET_SAVED_REPORTS
  }
}

const responseGetSavedReportsAction = (data) => {
  return {
    type: RESPONSE_GET_SAVED_REPORTS,
    data
  }
}

const requestGetSavedReportsFailureAction = (errors) => {
  return {
    type: REQUEST_GET_SAVED_REPORTS_FAILURE,
    errors
  }
}

const getSavedReports = (options) => {
  return (dispatch) => {
    dispatch(requestGetSavedReportsAction())

    reportService.getSavedReports(options)
      .then((result) => {
        dispatch(responseGetSavedReportsAction(result.data))
      })
      .catch((error) => {
        dispatch(requestGetSavedReportsFailureAction(error.response))

        if (error.response && error.response.status === 401) {
          dispatch(setLogout())
        }
      })
  }
}

export {
  getSavedReports,
  requestGetSavedReportsAction,
  responseGetSavedReportsAction,
  requestGetSavedReportsFailureAction,
  REQUEST_GET_SAVED_REPORTS,
  RESPONSE_GET_SAVED_REPORTS,
  REQUEST_GET_SAVED_REPORTS_FAILURE
}